<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="show"
      :close-on-click-modal="false"
      width="500px"
      class="addNewAppDialog"
      :append-to-body="true"
      top="3vh"
    >
      <div class="a-d-top">
        <div class="a-d-topTit">
          <div>{{ lang.publish }}</div>
        </div>
        <div class="a-d-t-right">
          <span @click.stop="close()">×</span>
        </div>
      </div>
      <div class="bfd_box" v-loading="loading" label-position="top">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <el-form-item
            v-if="agentDate.source != 'aiedit'"
            :label="lang.app_url"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <el-radio-group v-model="form.nurl">
              <el-radio :label="session_model_url" v-if="agentDate.muti_name">{{
                lang.chatMode
              }}</el-radio>
              <el-radio :label="card_type_url" v-if="agentDate.muti_name">{{
                lang.File_generation
              }}</el-radio>
              <el-radio :label="immersion_url" v-if="agentDate.muti_name">{{
                lang.immersion
              }}</el-radio>
              <el-radio :label="session_model_url" v-else>{{
                lang.chatMode
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="lang.set_visibility"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <el-radio-group v-model="form.njuri">
              <el-radio label="1">{{ `${lang.onlyOneself}【${lang.personal}】` }}</el-radio>
							
              <el-radio
                label="2"
                v-if="!isRestrictedOrgUser && user.org !=='97271986-97a1-11f0-a823-005056924926'"
              >{{ isAdmin==0?`${lang.publicity}【${lang.organization}】`:`${lang.publish_to_the_current_organization}【${lang.exclusive}】` }}</el-radio>
             
              <el-radio
                label="3"
                v-show="showAll && !isRestrictedOrgUser"
              >{{ lang.publishToAllOrganizations+`【${showAll==1?lang.authority:lang.winnow}】` }}</el-radio>
              
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="lang.app_limit"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <el-radio-group v-model="form.copy">
              <el-radio label="0">{{ lang.only_experience }}</el-radio>
              <el-radio label="1">{{ lang.allow_other }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- <el-form-item :label="lang.schoolStageTag">
            <div class="b_m_a_select">
							<div
								class="b_m_a_s_item"
								v-for="item in schoolStageList"
								:class="{choiceActive:form.schoolStage && form.schoolStage.includes(item.value)}"
								@click="clickSchoolStage(item.value)"
								:key="item.value"
							>
								<div class="singleChoice"></div>
								<span>{{ item.label }}</span>
							</div>
						</div>
          </el-form-item> -->


          <template v-if="cytag && cytag.length">
            <el-form-item :label="k.name" v-for="(k) in cytag" :key="k.id">
              <div class="b_m_a_select">
                <div
                  class="b_m_a_s_item"
                  v-for="item in k.children"
                  :key="item.id"
                  :class="{choiceActive:form.typeL && form.typeL.includes(item.id)}"
                  @click="clickCytag(item.id)"
                >
                  <div class="multipleChoices"></div>
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </el-form-item>
          </template>
          

          <!-- <el-form-item :label="lang.subject">
            <div class="b_m_a_select">
							<div
								class="b_m_a_s_item"
								v-for="item in subjectList"
								:key="item.value"
								:class="{choiceActive:form.subject && form.subject.includes(item.value)}"
								@click="clickSubject(item.value)"
							>
								<div class="multipleChoices"></div>
								<span>{{ item.label }}</span>
							</div>
						</div>
          </el-form-item> -->

          <el-form-item
            :label="lang.agent_sort"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <el-select v-model="form.ntype" :placeholder="lang.agent_sort">
              <el-option
                v-for="type in typeList"
                :key="type.id"
                :label="type.name"
                :value="type.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          
          <!-- <el-form-item
            :label="lang.app_status"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <el-radio-group v-model="form.status">
              <el-radio label="1">{{ lang.test }}</el-radio>
              <el-radio label="2">{{ lang.stabilize }}</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="bfd_bottom">
        <el-button @click="close()">{{ lang.cancel }}</el-button>
        <el-button type="primary" @click="submitBtn('ruleForm')">{{
          lang.confirm_publish
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isRestrictedOrg } from '@/common/org.js';
export default {
  props: {
    agentDate: {
      type: Object,
      default: () => {
        return {};
      },
    },
		releaseData:{
			type:[Object,null],
			default:()=>{
				return null;
			}
		}
  },
  data() {
    return {
      cyid:'',
      cytag:[],
      cyloading:false,
      immersion_url: '',
      card_type_url: '',
      session_model_url: '',
      typeList: [],
      loading: false,
      show: true,
      type: 1, //1添加，2编辑
      form: {
        nname: '',
        nlabel: '',
        ndetail: '',
        nurl: '',
        ntype: '',
        njuri: '1',
        copy: '0',
        nstand: '',
        njson: '',
        subject:[],
        schoolStage:[],
        // status:'1'
      },
      rules: {
        njuri: [
          { required: true, message: this.lang.app_limit, trigger: 'blur' },
        ],
      },
			juriListData:[],
			isAdmin:0,
      schoolStageList: this.lang.schoolStageTagList,
			subjectList: this.lang.subjectTagList
    }
  },
	computed:{
		showAll(){
			let _result = 0;

			if(this.juriListData.length>0){
				this.juriListData.forEach(i=>{
					let type = i.type;
					if(type=="oid"){
						type="organizeid"
					}else if(type=="userid"){
						type="userId"
					}

					if(i.jid==this.$store.state.user[type]){
						_result = i.utype
					}
				})
			}

			return _result;
		},
		isRestrictedOrgUser(){
			return isRestrictedOrg(this.user.organizeid);
		},
	},
  mounted() {
    console.log(1);
    this.cyid = ''
    if (this.agentDate.source == "agent" && this.agentDate.jsonData && JSON.parse(this.agentDate.jsonData).cyid) {
      this.cyid = JSON.parse(this.agentDate.jsonData).cyid
			this.getCyTag()
    }else if(this.agentDate.source == "muti_agent" && this.agentDate.content && JSON.parse(this.agentDate.content).cyid){
      this.cyid = JSON.parse(this.agentDate.content).cyid
			this.getCyTag()
    }
    this.get_type();
		this.getAppStoreJuri();
		this.getUserIsAdmin();
    this.form.nname = this.agentDate.muti_name ?? this.agentDate.assistantName;
    this.form.ndetail = this.agentDate.description;
    this.form.nlabel = this.agentDate.source == 'aiedit' ? this.agentDate.source : this.agentDate.muti_name?'workflow':'agent';
    this.form.nstand=this.user.orgArea;
    this.handle_url(this.agentDate.id);
		if(this.releaseData!=null){
			let _copyReleaseData = JSON.parse(JSON.stringify(this.releaseData));
			_copyReleaseData.json = JSON.parse(_copyReleaseData.json);
			this.form.copy = _copyReleaseData.json.copy;
			this.form.njuri = _copyReleaseData.juri;
			this.form.status = _copyReleaseData.json.status;
      this.form.subject = _copyReleaseData.json.subject?_copyReleaseData.json.subject:[];
      this.form.schoolStage = _copyReleaseData.json.schoolStage?_copyReleaseData.json.schoolStage:[];
			if(_copyReleaseData.json.modes){
				let mode = _copyReleaseData.json.modes[0];
				switch(mode){
					case "0":
						this.form.nurl = this.session_model_url;
						break;
					case "1":
						this.form.nurl = this.card_type_url;
						break;
					case "2":
						this.form.nurl = this.immersion_url;
						break;
					default:
						this.form.nurl = _copyReleaseData.url;
						break;
				}
			}else{
				if([this.session_model_url,this.card_type_url,this.immersion_url].includes(_copyReleaseData.url)){
					this.form.nurl = _copyReleaseData.url;
				}else{
					this.form.nurl = this.session_model_url;
				}
			}
		}
    if (this.isRestrictedOrgUser) {
      this.form.njuri = '1';
		}
  },
  methods: {
    getCyTag(){
			let params = {
				id:this.cyid,
			}
      this.cyloading = true
			this.ajax.get(this.$store.state.api+"getCyTag",params).then(res=>{
				let _data = res.data[0][0];
				this.cytag = JSON.parse(_data.typeL)
        this.cyloading = false
			}).catch(e=>{
        this.cyloading = false
				console.log(e);
			})
		},
    handle_url(agentId) {
      if(this.agentDate.source == 'aiedit'){
        switch (this.user.orgArea) {
          case 'cn':
            this.session_model_url =
              'https://aichat.cocorobo.cn/#/aiEdit?id=' +
              agentId +
              '&type=aiedit'
            break;
          case 'hk':
            this.session_model_url =
              'https://aichat.cocorobo.hk/#/aiEdit?id=' +
              agentId +
              '&type=aiedit';
            break;
          case 'com':
            this.session_model_url =
              'https://aichat.cocorobo.com/#/aiEdit?id=' +
              agentId +
              '&type=aiedit';
            break;
          default:
            this.session_model_url =
              'https://aichat.cocorobo.cn/#/?id=' +
              agentId +
              '&type=aiedit'
            break;
        }
      }else {
        switch (this.user.orgArea) {
          case 'cn':
            this.session_model_url =
              'https://aichat.cocorobo.cn/#/?id=' +
              agentId +
              '&type=' +
              (this.agentDate.muti_name ? 'mutiagent' : 'agent');
            if (window.location.href.includes('beta')) {
              this.card_type_url =
                'https://beta.knowledge.cocorobo.cn/zh-CN/run-agent-flow/' +
                agentId;
              this.immersion_url =
                'https://beta.knowledge.cocorobo.cn/zh-CN/story-telling/' +
                agentId;
            } else {
              this.card_type_url =
                'https://knowledge.cocorobo.cn/zh-CN/run-agent-flow/' +
                agentId;
              this.immersion_url =
                'https://knowledge.cocorobo.cn/zh-CN/story-telling/' +
                agentId;
            }
            break;
          case 'hk':
            this.session_model_url =
              'https://aichat.cocorobo.hk/#/?id=' +
              agentId +
              '&type=' +
              (this.agentDate.muti_name ? 'mutiagent' : 'agent');
            this.card_type_url =
              'https://knowledge.cocorobo.hk/zh-HK/run-agent-flow/' +
              agentId;
            this.immersion_url =
              'https://knowledge.cocorobo.hk/zh-HK/story-telling/' +
              agentId;
            break;
          case 'com':
            this.session_model_url =
              'https://aichat.cocorobo.com/#/?id=' +
              agentId +
              '&type=' +
              (this.agentDate.muti_name ? 'mutiagent' : 'agent');
            this.card_type_url =
              'https://knowledge.cocorobo.com/en-US/run-agent-flow/' +
              agentId;
            this.immersion_url =
              'https://knowledge.cocorobo.com/en-US/story-telling/' +
              agentId;
            break;
          default:
            this.session_model_url =
              'https://aichat.cocorobo.cn/#/?id=' +
              agentId +
              '&type=' +
              (this.agentDate.muti_name ? 'mutiagent' : 'agent');
            this.card_type_url =
              'https://knowledge.cocorobo.cn/zh-CN/run-agent-flow/' +
              agentId;
            this.immersion_url =
              'https://knowledge.cocorobo.cn/zh-CN/story-telling/' +
              agentId;
            break;
        }
      }

      this.form.nurl = this.session_model_url;
    },
    get_type() {
      this.$axios
        .get(
          'https://pbl.cocorobo.cn/api/pbl/select_appStoreType_exceptType?suserid=' +
            this.user.userId +
            '&sorg=' +
            this.user.org +
            '&soid=' +
            this.user.organizeid +
            '&sstand=' +
            this.user.orgArea +
            '&exportType='
        )
        .then((res) => {
          // console.log('res.data[0]',res.data[0]);
          let data = res.data[0]
          if(this.user.organizeid != '45facc0a-1211-11ec-80ad-005056b86db5'){
            this.typeList = data.filter(e=> e.id != "1e96dacf-c521-11f0-a424-005056924926");
          }else{
            this.typeList = data;
          }
          // 判断是否是学生且有作业分类
          if(this.user.type==2 && this.typeList.find(i=>i.id=='b64ad457-be72-11ef-a2d1-005056b86dbx')){
            this.typeList =  this.typeList.filter(e=>e.id=='b64ad457-be72-11ef-a2d1-005056b86dbx')
          }
					if(this.releaseData!=null){
						let _copyReleaseData = JSON.parse(JSON.stringify(this.releaseData));
						this.form.ntype = _copyReleaseData.type;
					}else{
						this.form.ntype = this.typeList[0].id
					}
        }).catch(()=>{
          // this.$message.error('服务器繁忙');
        })
    },
    open(data) {
      if (data && data.type === 2) {
        this.form = data.form;
        this.type = data.type;
      } else {
        this.form = {
          nname: '',
          nlabel: '',
          ndetail: '',
          nurl: '',
          ntype: '',
          njuri: '1',
          nstand: this.user.orgArea,
          njson: '',
          status:'1'
        };
      }
      this.loading = false;
      this.$parent.addAppDialogFlag = true;
    },
    close() {
      //if (this.loading && !flag) return this.$message.info('请稍等...');
      this.$parent.addAppDialogFlag = false;
      this.init();
    },
    init() {
      this.form = {
        nname: '',
        nlabel: '',
        ndetail: '',
        nurl: '',
        ntype: '',
        njuri: '1',
        nstand: this.user.orgArea,
        njson: '',
        status:'1'
      };
      this.loading = false;
    },
    submitBtn(ref) {
      // 创建工作流与智能体发布时共用一个接口，这里进行判断添加
      // console.log('ref',ref);
      // console.log('agentDate',JSON.parse(JSON.stringify(this.agentDate)));
      let yid = ''
      if (this.agentDate.source == "agent" && this.agentDate.jsonData && JSON.parse(this.agentDate.jsonData).cyid) {
        yid = JSON.parse(this.agentDate.jsonData).cyid
      }else if(this.agentDate.source == "muti_agent" && this.agentDate.content && JSON.parse(this.agentDate.content).cyid){
        yid = JSON.parse(this.agentDate.content).cyid
      }
      console.log('yid',yid);
      
      if (this.loading) return this.$message.info('请稍等...');
      this.$refs[ref].validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = this.form;
          let modes=""
        switch (this.form.nurl) {
          case this.session_model_url:
            modes="0"
            break;
          case this.card_type_url:
            modes="1"
            break;
          default:
            modes="2"
            break;
        }
        let params = {
              nname: data.nname, //app名称
              nuserid: this.agentDate.userId ||this.agentDate.userid || this.user.userId, //创建的用户ID
              nlabel: data.nlabel, //app标签
              ndetail: data.ndetail, //app简介
              nurl: data.nurl, //app链接
              ntype: data.ntype, //app类型
              njuri: data.njuri, //app权限 1:我的 2:组织 3:所有人
              nstand: this.user.orgArea, //语言
              //nstand:'hk'
              njson: JSON.stringify({ copy: data.copy,
                status:data.status,
                icon:this.agentDate.headUrl,
                modes:[modes],
                subject:data.subject,
                schoolStage:data.schoolStage,
                typeL: (data.typeL && data.typeL.length) ? data.typeL : '',
                cyid: yid ? yid : ''
              }), //其他信息
        };

        if(this.agentDate?.source == 'aiedit'){
          this.$axios
          .post(this.new_url + "/api/agents/publishAiEdit/"+this.agentDate.id, {
            status:1,
            modes:[modes],
            data:params
          }).then(res=>{
            if(res.status==200){
              this.$message.success(this.lang.released)
              this.loading = false;
							this.$parent.getReleaseData()
              this.$parent.addAppDialogFlag = false;
            }
          }).catch((error) => {
            console.log(error);
            // this.$message.error('服务器繁忙');
          });
        }else if(this.agentDate?.muti_name){
          this.$axios
          .post(this.new_url + "/api/agents/publishMutiAgent/"+this.agentDate.id, {
            status:1,
            modes:[modes],
            data:params
          }).then(res=>{
            if(res.status==200){
              this.$message.success(this.lang.released)
              this.loading = false;
							this.$parent.getReleaseData()
              this.$parent.addAppDialogFlag = false;
            }
          }).catch((error) => {
            console.log(error);
            // this.$message.error('服务器繁忙');
          });
        }else{
          this.$axios
          .post(this.new_url + "/api/agents/publishAgent/"+this.agentDate.id, {
            status:1,
            modes:[modes],
            data:params
          }).then(res=>{
            if(res.status==200){
              this.$message.success(this.lang.released)
              this.loading = false;
							this.$parent.getReleaseData()
              this.$parent.addAppDialogFlag = false; 
            }
          }).catch((error) => {
            console.log(error);
            // this.$message.error('服务器繁忙');
          });
        }
        }
      });
    },
				//获取显示标权限
				getAppStoreJuri(){
			this.ajax.get(this.$store.state.api+"select_appStorJuri").then(res=>{
				let _data = res.data;
				if(_data[0].length){
					this.juriListData = _data[0]
				}
			}).catch(e=>{
				console.log(e);
				console.log("获取权限失败")
			})
		},
		// 查询用户是否是管理员
		getUserIsAdmin(){
			this.ajax.get(this.$store.state.api+'select_userIsAdmin',{
				userId:this.user.userId
			}).then(res=>{
				let _data = res.data[0][0]
				this.isAdmin = _data.isAdmin;
			}).catch(e=>{
				console.log(e);
				console.log("获取是否是管理员失败")
			})
		},
    //切换学段
    clickSchoolStage(value){
			if(this.form.schoolStage){
				this.form.schoolStage = [value];
				// if(this.data.json.schoolStage.includes(value)){
				// 	this.data.json.schoolStage  = this.data.json.schoolStage.filter(i=>i!==value);
				// }else{
				// 	this.data.json.schoolStage.push(value)
				// }
			}else{
				this.form.schoolStage = [value];
			}
			this.$forceUpdate()
		},
    //切换学科
		clickSubject(value){
			if(this.form.subject){
				if(this.form.subject.includes(value)){
					this.form.subject  = this.form.subject.filter(i=>i!==value);
				}else{
					this.form.subject.push(value)
				}
			}else{
				this.form.subject = [value];
			}
			this.$forceUpdate()
		},
    //切换自定义分类
		clickCytag(value){
      console.log('value',value);
      
			if(this.form.typeL && this.form.typeL.length){
				if(this.form.typeL.includes(value)){
					this.form.typeL  = this.form.typeL.filter(i=>i!==value);
				}else{
					this.form.typeL.push(value)
				}
			}else{
				this.form.typeL = [value];
			}
			this.$forceUpdate()
		},

  },
};
</script>

<style scoped>
.bfd_box ::v-deep(.el-radio) {
  width: 100%;
  margin: 10px 0;
}
.addNewAppDialog >>> .el-dialog {
  min-width: 700px;

  /* height: 680px; */
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  background-color: #fff;
  /* top: 0px; */
  /* margin: 0 auto; */
  overflow: hidden;
}
.addNewAppDialog >>> .el-dialog__body {
  height: 100%;
  min-width: 700px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-bottom: 50px;
  padding-top: 10px;
}
.addNewAppDialog >>> .el-dialog__header {
  display: none !important;
}

.a-d-top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  border-bottom: 1px #ccc solid;
}
.a-d-top >>> .el-input__inner {
  width: 320px;
  height: 32px;
}
.a-d-top >>> .el-input__icon {
  line-height: 32px;
}

.a-d-topTit {
  /* width: 171px; */
  /* margin-left: 20px; */
  height: 32px;
  display: flex;
  font-weight: bold;
  font-size: 20px;
  align-items: center;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  line-height: 22px;
  justify-content: center;
  /* text-align: left; */
}

.a-d-t-right > span {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.bfd_bottom {
  display: flex;
  justify-content: flex-end;
  /* position: absolute;
  bottom: 10px;
  right:10px; */
}

.b_m_a_select {
  width: 100%;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.b_m_a_s_item {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 0px 12px;
	border: 2px solid #e5e7eb;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	font-size: 0.85rem;
	user-select: none;
	gap: 6px;
	display: flex;
	align-items: center;
	
}

.b_m_a_s_item>div{
	width: 13px;
	height: 13px;
	border: solid 1px #ccc;
	background: #fff;
	box-sizing: border-box;
	position: relative;
}

.b_m_a_s_item>div::after{
	content: '';
	width: 7px;
	height: 7px;
	position: absolute;
	top: 2px;
	left: 2px;
	background: #fff;
	transition: .2s ease;
}

.singleChoice{
	border-radius: 50%;
}

.singleChoice::after{
	border-radius: 50%;
	top: 2px;
	left: 2px;
}

.choiceActive{
	border-color: #409EFF !important;
  background: rgba(41, 92, 247, 0.05) !important;
  color: #409EFF !important;
}

.choiceActive>div::after{
	background: #409EFF;
}
</style>
